import {ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import {BaseDataSource} from '../../model/DataSources/BaseDataSource';
import {Subject} from 'rxjs/Subject';


export class BaseListComponent {
    dataSource: BaseDataSource<any>;
    loading = false;

    defaultFilters = {};
    filters: any = {};

    @ViewChild(MatPaginator) paginator: MatPaginator;

    dataChangedEventSubject: Subject<boolean> = new Subject<boolean>();

    pageSize = 10;
    pageSizeOptions: number[] = [5, 10, 25, 100];
    initialPageIndex = 0;


    constructor() {
        this.resetFilters(false);
    }

    getDataSize() {
        return this.dataSource.dataSize;
    }

    reloadPage(): void {
        this.dataChangedEventSubject.next(true);
    }

    resetFilters(reload: boolean = true): void {

        for (const k in this.defaultFilters) {
            if (!this.defaultFilters.hasOwnProperty(k)) {
                continue;
            }

            // Special if it is Date
            if (this.defaultFilters[k] instanceof Date) {
                this.filters[k] = new Date(this.defaultFilters[k].getTime());
            } else {
                this.filters[k] = JSON.parse(JSON.stringify(this.defaultFilters[k]));
            }
        }

        if (reload) {
            this.reloadPage();
        }
    }

}



// WEBPACK FOOTER //
// /app/src/SharedModule/BaseListComponent/base-list.component.ts